import React, { useEffect, useState } from 'react';
import { fetchTokens } from '../lib/api';
import TokenCard from '../components/TokenCard';
import StatsWidget from '../components/StatsWidget';
import Leaderboard from '../components/Leaderboard';
import { Compass, RefreshCw } from 'lucide-react';

const Explore = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const load = async () => {
    setLoading(true);
    setErr(null);
    try {
      const data = await fetchTokens();
      setTokens(data);
    } catch (e) {
      setErr(e?.message || 'Failed to load feed');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4 pb-6">
        <div>
          <span className="cf-chip"><Compass className="w-3 h-3" /> Public feed</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-3">
            Every coin <span className="cf-gradient-text">ever forged.</span>
          </h1>
          <p className="text-forge-muted text-sm mt-3 max-w-xl">
            Sorted newest first. Every token is fully on-chain — click through to see it on the block explorer.
          </p>
        </div>
        <button onClick={load} data-testid="refresh-feed-btn" className="cf-btn-secondary text-sm">
          <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} /> Refresh
        </button>
      </div>
      <StatsWidget />
      <Leaderboard />
      <div className="cf-divider my-10" />

      {loading && (
        <div data-testid="feed-loading" className="text-forge-muted mt-10 text-sm animate-pulse">
          Loading feed…
        </div>
      )}
      {err && <div className="text-[#FF6B7A] mt-10 text-sm">{err}</div>}

      {!loading && !err && tokens.length === 0 && (
        <div data-testid="feed-empty" className="mt-10 cf-card p-16 text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-[#7DF9FF]/20 to-[#A78BFA]/20 flex items-center justify-center mb-4">
            <Compass className="w-8 h-8 text-[#7DF9FF]" />
          </div>
          <h3 className="font-display text-2xl font-bold">No tokens yet</h3>
          <p className="text-forge-muted text-sm mt-2">Be the first to forge a coin.</p>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5" data-testid="tokens-grid">
        {tokens.map((t) => (
          <TokenCard key={t.id || `${t.contract_address}-${t.chain_id}`} token={t} />
        ))}
      </div>
    </div>
  );
};

export default Explore;
